import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Purpose } from 'src/app/shared/models/purpose.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-purpose-create-modal',
  templateUrl: './purpose-create-modal.component.html',
  styleUrls: ['./purpose-create-modal.component.scss']
})
export class PurposeCreateModalComponent implements OnInit {

  purposeForm: FormGroup;
  @Input() purpose: Purpose;
  isEdit: boolean;

  constructor(public activeModal: NgbActiveModal,
              private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.purposeForm = this.formBuilder.group({
      purpose_id   : [0],
      name         : ['', [Validators.required, Validators.maxLength(25)]],
      description  : ['', [Validators.maxLength(250)]],
      is_preview   : [false]
    });

    if (this.purpose) {
      this.isEdit = true;
      this.purposeForm.patchValue({
          purpose_id   : this.purpose.purpose_id,
          name         : this.purpose.name,
          description  : this.purpose.description,
          is_preview   : this.purpose.is_preview
        });

        this.purposeForm.updateValueAndValidity();
    }
  }

  close() {
    this.activeModal.close(
      this.purposeForm.value
    );
  }
}
